import { render } from "./404.vue?vue&type=template&id=9dff4920&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=9dff4920&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dff4920"]])

export default __exports__